<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <c-search-form
            :rows-per-page-items="1000"
            :page-size="1000"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="weekId"
            :search-url="search_url"
            create-url="/kidWeek/save"
            delete-url="/kidWeek/delete"
            form-type="intable"
            custom-create-new
            custom-edit-item
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptBack="4001"
            :acceptDelete="false"
            :acceptView="false"
            :accept-create="false"
            :accept-select="false"
        >
        </c-search-form>
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/admin/week/WeekCreate";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Babiclass Live Class",
      formCreateName: "Thêm mới tuần học",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      programName: null,
      search_url: null,
      ageId: null,
      ageName: null,
      levelNumber: null,
      levelId: null,
      weekTotal: null,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'createDate',
          text: 'Thời gian',
          sortable: false,
          search: true,
          dateFormat: 'dd/MM/yyyy hh:mm',
          width: "10%",
          headerStyle: "text-align:center",
        },
        {
          value: 'liveName',
          text: 'Tên bài học',
          sortable: false,
          search: true,
          width: "20%",
          headerStyle: "text-align:center",
        },
        {
          value: 'step',
          text: 'Step',
          sortable: false,
          search: true,
          width: "15%",
          headerStyle: "text-align:center",
        },

      ],
    };
  },

  created() {
    this.search_url = "/liveClassPointInfo/search/"+ this.$route.params.id;
  },


  methods: {
  },

  destroyed() {
  },
};
</script>
